import { gql } from '@apollo/client';

/**
{
    "search": {
      "all": true,
      "q": "",
      "dates": [],
      "page": 1,
      "perPage": 10,
    }
  }
*/

export const ListIncomes = gql`
  query ListIncomes($search: SearchPurchasesInput!) {
    listIncomes(input: $search) {
      docs {
        _id
        user {
          _id
          email
          fullName
        }
        createdAt
        currency
        price
        commission_percentage
        takehome_percentage
        membershipPeriod
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;
